import i18next from 'app/translations/i18n';
import { enIN, es } from 'date-fns/locale';
import 'moment/locale/es';
import moment from 'moment/moment';

export function getFormat() {
  return i18next.language === 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
}

export function getDateFormat(date) {
  const dateDate = new Date(date);
  return date ? moment(dateDate).format(i18next.language === 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY') : '';
}

export function getDateFormatText(date) {
  const dateDate = new Date(date);
  const locale = i18next.language.toLowerCase();
  return moment(dateDate).locale(locale).format('LL');
}

export function getDateFormatAPI(date) {
  const dateDate = new Date(date);
  return moment(dateDate).format('YYYY-MM-DD');
}

export function getDateFormatServer(date) {
  const dateDate = new Date(date);
  return moment(dateDate).format('YYYY-MM-DD HH:mm:ss');
}

// El servidor marca las caducidades como UTC aunque solo representan un día: leerlas con la zona
// del navegador desplaza el día y, al reenviarlas, acumula el desfase horario en cada guardado.
export function parseServerDay(date) {
  if (!date) return '';

  const day = typeof date === 'string' ? date.slice(0, 10) : getDateFormatAPI(date);

  return `${day}T00:00:00`;
}

export function getDateJS(date) {
  return date ? new Date(date) : new Date();
}

export function getLocale() {
  return i18next.language === 'es' ? es : enIN;
}

export function timestampPrventCache() {
  return `?t=${new Date().getTime()}`;
}

export function getDateRanges(t) {
  return [
    { value: 'HOUR', label: t('common:hours'), labelSingular: t('common:hour') },
    { value: 'DAY', label: t('common:days'), labelSingular: t('common:day') },
    { value: 'WEEK', label: t('common:weeks'), labelSingular: t('common:week') },
    { value: 'MONTH', label: t('common:months'), labelSingular: t('common:month') },
    { value: 'YEAR', label: t('common:years'), labelSingular: t('common:year') },
  ];
}
